import { render, staticRenderFns } from "./ChenWuEdit.vue?vue&type=template&id=29bb7507&scoped=true"
import script from "./ChenWuEdit.vue?vue&type=script&lang=js"
export * from "./ChenWuEdit.vue?vue&type=script&lang=js"
import style0 from "./ChenWuEdit.vue?vue&type=style&index=0&id=29bb7507&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bb7507",
  null
  
)

export default component.exports